<template>
  <b-link class="btn-social" :class="{ onlyIcon: onlyIcon }" @click="action">
    <b-img
      class="w-24"
      :class="{ onlyIcon: onlyIcon, 'btn-social-margin': !onlyIcon }"
      :src="getImage"
      :alt="$t('continueWithFacebook')"
    ></b-img>
    <template v-if="!onlyIcon">
      {{ $t("continueWithFacebook") }}
    </template>
  </b-link>
</template>

<script>
export default {
  name: "UiFacebook",
  props: {
    action: {
      type: Function,
      default: null
    },
    onlyIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getImage() {
      return !this.onlyIcon
        ? `${this.publicPath}assets/images/icons/facebook.svg`
        : `${this.publicPath}assets/images/facebook.png`;
    }
  },
  methods: {
    checkLoginState() {
      window.FB.getLoginStatus(function(response) {
        console.log(response, "checkLoginState");
        // statusChangeCallback(response);
      });
    }
  }
};
</script>
